import { type IconProps } from '@compass/Icon/types'
import { cn } from '@compass/utils'

import golStyles from './styles/GridIconGoL.module.css'
import protectStyles from './styles/GridIconProtect.module.css'

const GRID_FILL = 'hsl(var(--fpds-color-orange-7))'

function GridIconSvg({ size = 16, width, height, className, ...props }: IconProps) {
  return (
    <svg
      className={className}
      width={width ?? size}
      height={height ?? size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <rect width='2' height='2' fill={GRID_FILL} />
      <rect x='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='7' width='2' height='2' fill={GRID_FILL} />
      <rect x='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='14' width='2' height='2' fill={GRID_FILL} />
      <rect y='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='3.5' y='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='7' y='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='10.5' y='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='14' y='3.5' width='2' height='2' fill={GRID_FILL} />
      <rect y='7' width='2' height='2' fill={GRID_FILL} />
      <rect x='3.5' y='7' width='2' height='2' fill={GRID_FILL} />
      <rect x='7' y='7' width='2' height='2' fill={GRID_FILL} />
      <rect x='10.5' y='7' width='2' height='2' fill={GRID_FILL} />
      <rect x='14' y='7' width='2' height='2' fill={GRID_FILL} />
      <rect y='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='3.5' y='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='7' y='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='10.5' y='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect x='14' y='10.5' width='2' height='2' fill={GRID_FILL} />
      <rect y='14' width='2' height='2' fill={GRID_FILL} />
      <rect x='3.5' y='14' width='2' height='2' fill={GRID_FILL} />
      <rect x='7' y='14' width='2' height='2' fill={GRID_FILL} />
      <rect x='10.5' y='14' width='2' height='2' fill={GRID_FILL} />
      <rect x='14' y='14' width='2' height='2' fill={GRID_FILL} />
    </svg>
  )
}

function GridIconBase(props: IconProps) {
  return <GridIconSvg {...props} />
}

function GridIconGoL({ className, ...props }: IconProps) {
  return <GridIconSvg className={cn(golStyles.glider, className)} {...props} />
}

function GridIconProtect({ className, ...props }: IconProps) {
  return <GridIconSvg className={cn(protectStyles.protect, className)} {...props} />
}

const GridIcon = Object.assign(GridIconBase, {
  GoL: GridIconGoL,
  Protect: GridIconProtect,
}) as typeof GridIconBase & {
  GoL: typeof GridIconGoL
  Protect: typeof GridIconProtect
}

export { GridIcon }
